import styled from 'styled-components';

export const StyledTableHeaderWithDate = styled.th`
  width: 6rem !important;
  min-width: 5.2rem !important;
  max-width: 10rem !important;
  padding: 0px !important;
`;

export const StyledCutOff = styled.td`
  &,
  select {
    min-width: 3.5rem !important;
  }
`;
